import gql from 'graphql-tag';

const CREATE_GOOGLE_OAUTH = gql`
  mutation createGoogleOAuth($orgId: String!) {
    createGoogleOAuth(orgId: $orgId) {
      id
      name
      orgId
      clientId
      redirectUri
      tokenType
      tokenScope
      expiryDate
      createdAt
      updatedAt
    }
  }
`;

export default CREATE_GOOGLE_OAUTH;
